module.exports = __webpack_public_path__ + "img/go_version_terminal.d5f0cdd4.png";